// Angular + external
import { Component, OnDestroy, ViewChild } from "@angular/core";
import { AutoComplete } from "@bfx/primeng/autocomplete";
import { Observable, Subject } from "rxjs";
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
import { BfxDialogData } from "./models/bfx-dialog-data.model";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { BfxPublicProfileSaveActionEvent } from "../bfx-common/models/user-profile-public";

@Component({
  selector: "bfx-dialog-public-profile-save",
  templateUrl: "./html/bfx-dialog-public-profile-save.html",
  standalone: false,
})
export class BfxDialogPublicProfileSaveComponent
  extends BfxDialogBaseComponent
  implements OnDestroy
{
  @ViewChild("_saveProfile_publicProfileName_autoComplete", { static: true })
  private _saveProfile_publicProfileName_autoComplete: AutoComplete;
  private savePublicProfileCallback: any;
  public profileNameValid: boolean = false;
  public profileNameEmpty: boolean = true;

  /***************************************/
  /* DATA */
  public config: any = {
    debug: true,
  };

  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      height: 150,
      title_text: "Save Public Profile",
      autocomplete_publicProfileName: "",
      message_text_invalid: "",
    },
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(private _translationService: TranslateService) {
    super();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public openDialog(dialogData: BfxDialogData): Observable<any> {
    this.data.dialogId = dialogData.dialogId;
    let event: BfxPublicProfileSaveActionEvent = dialogData.event;
    this.data.actionEvent = event;
    this.savePublicProfileCallback = this.data.actionEvent._callback;
    this.data.dialogData.show = true;

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    super.closeDialog();

    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionSaveProfile_confirm(): void {
    this.savePublicProfileCallback(this.data.dialogData.autocomplete_publicProfileName);
    this.closeDialog();
  }

  public actionSaveProfile_close(): void {
    this.closeDialog();
  }

  public helpersaveProfile_validateProfileName(event: any) {
    if (event.length == 0) {
      this.profileNameValid = false;
      this.profileNameEmpty = true;
      return;
    }
    if (event.length > 50) {
      this.profileNameValid = false;
      this.profileNameEmpty = false;
      this.data.dialogData.message_text_invalid = this._translationService.instant(
        "public.profile.name.too.long",
      );
      return;
    } else {
      this.profileNameValid = true;
      this.profileNameEmpty = false;
      this.data.dialogData.autocomplete_publicProfileName = event;
    }
  }
}
